import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { tokens, IconButton } from '@hotjar/hotsauce';
import { capitalize } from '@hotjar/insights-common/lib/string';

import { SMART_PANEL_SPACING } from '../../constants-types/Layout';

export const SmartPanelSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 4px solid ${tokens.color.ui_border_light};

  &:last-of-type {
    border-bottom: 0;
  }
`;

export const SmartPanelSegment = styled.div<{ keepLastBorder?: boolean }>`
  display: flex;
  width: 100%;
  padding: ${SMART_PANEL_SPACING};
  border-bottom: 1px solid ${tokens.color.ui_border_light};

  ${({ keepLastBorder }) =>
    !(keepLastBorder ?? false) &&
    css`
      &:last-of-type {
        border-bottom: 0;
      }
    `}
`;

export const SmartPanelSegmentColumn = styled(SmartPanelSegment)`
  flex-direction: column;
`;

export const SmartPanelSecondaryView = ({
  onDeActivateSecondaryView,
  children,
}: {
  onDeActivateSecondaryView: () => void;
  children: React.ReactNode;
}): JSX.Element => {
  const { t } = useTranslation('heatmaps');
  const backText = capitalize(t('general-terms.back'));

  return (
    <>
      <SmartPanelSegment>
        <IconButton
          kind="ghost"
          icon="arrow_left_alone"
          size="s"
          title={backText}
          tooltipText={backText}
          description={backText}
          onClick={onDeActivateSecondaryView}
        />
      </SmartPanelSegment>
      {children}
    </>
  );
};
